var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 12.1384V3.86159C4 3.47768 4.41474 3.23699 4.74807 3.42747L11.9903 7.56588C12.3262 7.75783 12.3262 8.24217 11.9903 8.43412L4.74807 12.5725C4.41474 12.763 4 12.5223 4 12.1384Z","fill":"currentColor"}));
}

Play.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Play;

Play.default = Play;
